<template>
    <mdb-container fluid>
      <mdb-row>
        <mdb-col md="2">
            <div class="form-group">
                <mdb-date-picker :autoHide="true" v-model="date_from" label="Date From" />
            </div>
        </mdb-col>
        <mdb-col md="2">
            <div class="form-group">
                <mdb-date-picker :autoHide="true"  v-model="date_to" label="Date To" />
            </div>
        </mdb-col>
        <mdb-col md="3" class="d-flex align-items-center">
          <input v-on:keyup.enter="searchData()" v-model="batch_ref_no" type="text" placeholder="#Batch Ref No." class="form-control">
        </mdb-col>
        <mdb-col md="3" class="d-flex align-items-center">
          <input v-on:keyup.enter="searchData()" v-model="wallet_withdrawal_name" type="text" placeholder="#Batch Name" class="form-control">
        </mdb-col>
        <mdb-col md="2" class="d-flex align-items-center">
            <mdb-btn @click="searchData()" v-if="!loading" outline="primary" size="sm"><mdb-icon icon="search" /> Search</mdb-btn>
            <mdb-spinner small v-if="loading" />
        </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col col="12">
          <mdb-spinner small v-if="excel_loading" />
          <mdb-btn outline="info" size="sm" v-if="!loading && !excel_loading" @click="downloadExcel()"><mdb-icon icon="file-excel" /> Download Excel within Duration</mdb-btn>
      </mdb-col>
    </mdb-row>
    <mdb-tbl responsive striped v-if="!loading">
      <mdb-tbl-head>
      <tr>
          <th width="5%">#</th>
          <th><div>DateTime</div></th>
          <th><div>Batch Name</div></th>
          <th><div>Batch Ref No.</div></th>
          <th><div>Admin</div></th>
          <th><div class="text-right">Count</div></th>
          <th class="text-right"><div>Amount(RM)</div></th>
          <th width="20%" class="text-center"><div>Action</div></th>  
      </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
      <tr v-for="(batch, index) in batches" :key="batch.id">
          <td>{{index+1}}</td>
          <td>{{momentFormat16(batch.created_at)}}</td>
          <td>{{batch.wallet_withdrawal_name}}</td>
          <td>
            <div class="link-text" @click="hyperlinkList(batch.reference_number)">{{batch.reference_number}}</div>
            <div class="text-success">{{batch.remark}}</div>
          </td>
          <td>
            <div v-if="batch.admin!=null">Submitted: <span class="text-info">{{batch.admin.name}}</span></div>
            <div v-if="batch.admin_approved!=null">Approved: <span class="text-success">{{batch.admin_approved.name}}</span></div>
          </td>
          <td class="text-right">
              {{batch.total_count}}
          </td>
          <td class="text-right">{{batch.total_withdrawal_amount}}</td>
          <td>
            <div class="d-flex flex-row justify-content-around align-items-center">
              <mdb-tooltip trigger="hover" v-if="batch.is_approved==0" :options="{placement: 'top'}">
                <span slot="tip">Approve</span>
                <a @click="continueApprove(batch)" slot="reference">
                  <mdb-icon icon="check" />
                </a>
              </mdb-tooltip>
              <mdb-tooltip v-if="batch.is_approved==1" trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Approved</span>
                <a slot="reference">
                  <mdb-icon icon="check" class="text-success" />
                </a>
              </mdb-tooltip>
              <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Download Biz Convertor</span>
                <a @click="downloadFile(batch.banking_path)" slot="reference">
                  <mdb-icon far icon="file-excel" />
                </a>
              </mdb-tooltip>
              <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Download Withdrawal Records</span>
                <a @click="downloadFile(batch.excel_path)" slot="reference">
                  <mdb-icon far icon="file-excel" />
                </a>
              </mdb-tooltip>
            </div>
          </td>
      </tr>
      </mdb-tbl-body>
    </mdb-tbl>  
    <PartnerWithdrawalBatchApprovalModal :visible="parnter_withdrawal_batch_approval_modal" :close="closeModal" :submit="submitWithdrawalApproval" :batch="focus_batch" />
    </mdb-container>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbCol, mdbRow, mdbSpinner, mdbDatePicker, mdbIcon, mdbBtn, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip} from 'mdbvue';
import {ajax} from '../js/ajax';
import {momentFormat16} from '../js/helper';
import { APP_STORAGE_URL } from '../js/config';
import PartnerWithdrawalBatchApprovalModal from '../components/PartnerWithdrawalBatchApprovalModal'

export default {
  name: 'partner_withdrawal_batch',
  components: {
    mdbContainer, mdbCol, mdbRow, mdbSpinner, mdbDatePicker, mdbIcon, mdbBtn, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip,
    PartnerWithdrawalBatchApprovalModal
  },
  props: ['navigate'],
  data: ()=>({
    loading:false,
    date_from: "",
    date_to: "",
    batches: [],
    parnter_withdrawal_batch_approval_modal: false,
    focus_batch: null,
    action_loading:false,
    batch_ref_no: "",
    excel_loading: false,
    wallet_withdrawal_name: ""
  }),
  methods: {
    closeModal(){
      this.parnter_withdrawal_batch_approval_modal=false;
    },
    getData(){
      if(this.loading){
        return false;
      }
      this.loading=true;
      ajax({
        url: "admin/get_partner_withdrawals_batch",
        data: {
            date_from: this.date_from,
            date_to: this.date_to,
            batch_ref_no: this.batch_ref_no,
            wallet_withdrawal_name: this.wallet_withdrawal_name
        },
        complete: ()=>this.loading=false,
        success: result=>{
          this.batches=result.data;
        },
      }, this)
    },
    momentFormat16(date){
      return momentFormat16(date);
    },
    downloadFile(file){
      window.open(APP_STORAGE_URL+file);
    },
    continueApprove(batch){
      if(batch.is_approved==1){
        this.$notify.success({message: batch.wallet_withdrawal_name+' has been approved.', position:'top right', timeOut: 5000});
        return false;
      }
      this.parnter_withdrawal_batch_approval_modal=true;
      this.focus_batch=batch;
    },
    submitWithdrawalApproval(text){
      if(this.action_loading){
        return false;
      }
      this.action_loading=true;
      ajax({
        url: "admin/submit_batch_approval",
        data: {
            id: this.focus_batch.id,
            remark: text
        },
        complete: ()=>this.action_loading=false,
        success: ()=>{
          this.searchData();
        },
      }, this)
    },
    searchData(){
      this.batches=[];
      this.getData();
    },
    accept(obj){
      this.batch_ref_no=obj;
      this.searchData();
    },
    hyperlinkList(ref_no){
      this.navigate(ref_no)
    },
    downloadExcel(){
      this.excel_loading=true;
      ajax({
          url: "admin/excel_partner_wallet_batches",
          data: {
            date_from: this.date_from,
            date_to: this.date_to,
          },
          success: ()=>{
            this.$notify.success({message: 'Downloaded Document will be available in few minutes time', position:'top right', timeOut: 5000});
          },
          complete: ()=>this.excel_loading=false,
          fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
      })
    },
  },
  mounted: function(){
    let date = new Date();
    let month = date.getMonth()+1;
    this.date_from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.date_to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.getData();
  }
}
</script>

<style scoped>
.link-text:hover{
    color: #4285F4;
    font-weight: bold;
}
.link-text{
    font-weight: bold;
}
</style>